import Empty from '@components/Empty'
import NormalMultiline from '@components/Multiline'
import ArticleMultiline from '@components/Multiline/Article'
import CustomGridMultiline from '@components/Multiline/CustomGrid'
import MegaModuleMultiline from '@components/Multiline/MegaModule'
import DossierMultiline from '@components/Multiline/Dossier'
import WebarchiveMultiline from '@components/Multiline/Webarchive'
import SectionContentMultiline from '@components/Multiline/SectionContent'
import HighFiveMultiline from '@components/Multiline/HighFive'
import contextLayoutMultiLine from '@contexts/layoutMultiLine'
import { FunctionComponent } from 'react'
import { CookWidget } from '@widgets/types'
import { MultilineProps, ValidDataWithNormalContent } from './types'
import {
  contentWithoutNativeOnlyAds,
  hasArticleContent,
  hasDossierContent,
  hasMegaModule,
  hasPaginatedContent,
  hasValidData,
  hasWebarchiveContent,
  isHighFive,
  isMultilineGrid,
} from './utils'

const { LayoutMultiLineContext } = contextLayoutMultiLine

const Multiline: FunctionComponent<MultilineProps> = (props) => {
  let Wrapper: FunctionComponent<any> = Empty
  let contentWithoutNativeAds

  if (!hasValidData(props)) {
    return null
  } else if (hasArticleContent(props)) {
    Wrapper = ArticleMultiline
    contentWithoutNativeAds = props.content
  } else if (hasMegaModule(props)) {
    Wrapper = MegaModuleMultiline
    contentWithoutNativeAds = props.content
  } else if (hasPaginatedContent(props)) {
    Wrapper = SectionContentMultiline
    contentWithoutNativeAds = props.content
  } else if (hasDossierContent(props)) {
    Wrapper = DossierMultiline
    contentWithoutNativeAds = props.content
  } else if (hasWebarchiveContent(props)) {
    Wrapper = WebarchiveMultiline
    contentWithoutNativeAds = props.content
  } else if (isMultilineGrid(props)) {
    Wrapper = CustomGridMultiline
    contentWithoutNativeAds = contentWithoutNativeOnlyAds(props.content)
  } else if (isHighFive(props)) {
    Wrapper = HighFiveMultiline
    contentWithoutNativeAds = props.content
  } else {
    Wrapper = NormalMultiline
    contentWithoutNativeAds = contentWithoutNativeOnlyAds(
      (props as ValidDataWithNormalContent).content
    )
  }

  return (
    <LayoutMultiLineContext.Provider
      value={{
        isVideoBlock: props.options?.blockType === 'video',
        grid: props?.options?.grid,
      }}>
      <Wrapper>{contentWithoutNativeAds}</Wrapper>
    </LayoutMultiLineContext.Provider>
  )
}

const widget: CookWidget = {
  kind: ['layout', 'multi-line'],
  component: Multiline,
}

export default widget
